import Vue from "vue";
import "whatwg-fetch"; // polyfill fetch (<2017)
import "promise-polyfill/src/polyfill";
import { searchresults } from "./searchresults";

document.addEventListener("DOMContentLoaded", function onDomReady() {

    document.removeEventListener("DOMContentLoaded", onDomReady, false);
    const elementID = "vue-searchpage";
    const element = document.getElementById(elementID);

    if (element) {
        const raw = JSON.parse(element.dataset.raw);
        const types = JSON.parse(element.dataset.types);
        search.init(elementID, types, raw);
    }
});

const search = {
    view: null,

    init: function (elementID, types, raw) {
        this.view = new Vue({
            el: "#" + elementID,
            data: {
                results: raw.results,
                types: types,
                resultsamount: 0
            },
            created: function () {
                this.resultsamount = this.results.page.items.length + this.results.post.items.length;
            },
            watch: {
            },
            methods: {
            }
        });
    }
};

export { search };
